import { useState } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer';
import TourSection from '../TourSection/TourSection';
import Breadcrumb from "../Breadcrumb";
import ToursHero from '../components/Tour/TourHero';
import TourAudience from '../components/Tour/TourAudience';

const SHOW_TOUR_AUDIENCE = false;

  const pathData = [
    { path: '/', title: 'Home' },
    { path: '/tours', title: 'Tours' }
  ];

const ToursPage = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  return (
    <>
      <Header logoColor="dark" />
      <Breadcrumb pathData={pathData} />
      <main>
        <ToursHero />
        {SHOW_TOUR_AUDIENCE && (
          <TourAudience
            activeFilter={activeFilter}
            onSelectFilter={setActiveFilter}
          />
        )}
        <TourSection
          activeFilter={activeFilter}
          onChangeFilter={setActiveFilter}
        />
      </main>

      <Footer />
    </>
  );
};

export default ToursPage;
